<template>
  <div class="d-flex flex-column align-center">
    <v-icon size="32" class="mb-3" color="blue-grey lighten-1">{{
      icon
    }}</v-icon>
    <p class="body-2 ma-0 pa-0 mb-2 blue-grey--text text--darken-1 ">
      {{ textTitle }}
    </p>
    <p class="body-2 ma-0 pa-0 blue-grey--text ">
      {{ textSubtitle }}
    </p>
  </div>
</template>
<script>
export default {
  name: 'RecognitionListEmptyState',
  props: {
    hasActiveFilters: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    icon() {
      return this.hasActiveFilters
        ? 'mdi-ghost-outline'
        : 'mdi-hand-heart-outline'
    },
    textTitle() {
      return this.hasActiveFilters
        ? this.$t('recognitions.empty_title_filters')
        : this.$t('recognitions.empty_title')
    },
    textSubtitle() {
      return this.hasActiveFilters
        ? this.$t('recognitions.empty_subtitle_filters')
        : this.$t('recognitions.empty_subtitle')
    },
  },
}
</script>
